module.exports = __webpack_public_path__ + "static/media/HCMM282.f39255e3.jpg";